import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_cadena_id: new EntityColumn<string>({ name: 'c_cadena_id', type: 'char', length: 20, flags: c.PK, prompt: 'ID', description: 'Ingrese el código de la cadena' }),
        vc_cadena_nombre: new EntityColumn<string>({ name: 'vc_cadena_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Descripción', description: 'Ingrese la descripción para la cadena' }),
        vc_codigoexterno: new EntityColumn<string>({ name: 'vc_codigoexterno', type: 'varchar', length: 50, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Código externo' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        cade_brwStandard: { name: 'cade_brwStandard', keyMappings: { c_cadena_id: 0 } }
    }
)

export class CadenasDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('Cadenas');
    }
}